import {authService} from '../../service/authService'
import router from '../../router'

export const namespaced = true

export const state = {
  currentUser: null,
  isLogin: null,
}

export const mutations = {
  SET_CURRENT_USER(state, payload) {
    state.currentUser = payload
  },
  SET_IS_LOGIN(state, payload) {
    state.isLogin = payload
  },
}

export const getters = {
  getCurrentUser(state) {
    return state.currentUser
  },
  getIsLogin(state) {
    return state.isLogin
  },
}

export const actions = {
  async fakeLogin({commit}, payload){
    await authService().setToken('eyJhbGciOiJFUzI1NiIsImtpZCI6IjdqenJVakg0NldETTQyRUUwZ0NuTkEiLCJ0eXAiOiJhdCtqd3QifQ.eyJuYmYiOjE2NDk0ODc5NjAsImV4cCI6MTY0OTQ5MTU2MCwiaXNzIjoiaHR0cHM6Ly9hY2NvdW50cy5pZGFsbC5wcm8iLCJhdWQiOiJwb3JzYW4tYXBpIiwiY2xpZW50X2lkIjoidGVieWFuLXBvcnNhbi1hZG1pbiIsInN1YiI6IndtNWc3NXgzM3Q3eWZhajZnbThwY2M3djR1IiwiYXV0aF90aW1lIjoxNjQxOTY5MTYwLCJpZHAiOiJsb2NhbCIsImp0aSI6ImVTSVJrNG9pN0ZEM21wQVN3MFRJMUEiLCJzY29wZSI6WyJwaG9uZSIsInByb2ZpbGUiLCJvcGVuaWQiLCJkaXNwbGF5X25hbWUiLCJwb3JzYW4tYXBpLnVzZXIiLCJwb3JzYW4tYXBpLmFkbWluIiwib2ZmbGluZV9hY2Nlc3MiXSwiYW1yIjpbInB3ZCJdfQ.HY2y5fZXGp_yGLhH8E4jA9168myqwpBJEpErjIme5UzR5vnCDL058ceLW82aYoK1STTCJoZvhvG6Os6W5_vAYw')
    commit('SET_IS_LOGIN', true)
  },
  async login({commit}, payload) {
    const {data} = await authService().login(payload)
    if (data.data) {
      await authService().setToken(data.data)
    }
    return data
  },
  async logout({commit}) {
      await authService().removeToken()
      //commit('SET_CURRENT_USER', null)
      await router.push({name: 'Login'})
  },
}
